var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"p-2 mr-1 rounded-t transition transform hover:bg-primary hover:text-black",class:_vm.classObject,attrs:{"type":"menu"}},[_vm._v(" "+_vm._s(_vm.tab)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }